/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';
import { Colors, Text } from '@zapier/design-system';

type TaskLimitDropdownSubstituteProps = {
  /** The background color of the component. */
  color?: string;
  /** The text to display. */
  text: string;
};

const rootStyles = (color: string) => css`
  align-items: center;
  background: ${color};
  border-radius: 10px;
  display: flex;
  height: 40px;
  padding: 8px 15px;
`;

/**
 * Used in place of a `TaskLimitDropdown` component when there's only one item to display.
 */
export const TaskLimitDropdownSubstitute = ({
  color = Colors.grey100,
  text,
}: TaskLimitDropdownSubstituteProps) => (
  <div css={rootStyles(color)}>
    <Text fontWeight={600} tag="p" type="altText900">
      {text}
    </Text>
  </div>
);
